import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";
import userApi from "./userApi";

export const getApplicationUserEdit = createThunkFromApi(
  "notification/getApplicationUserEdit",
  userApi.getApplicationUserEdit
);

export const getUser = createThunkFromApi(
  "notification/getUser",
  userApi.getUser
);

export const applicationUserPaymentFeeWithUSDT = createThunkFromApi(
  "notification/applicationUserPaymentFeeWithUSDT",
  userApi.applicationUserPaymentFeeWithUSDT
);

const initialState = {
  user: null,
};

export const userSlice = createSlice({
  name: "notification",
  initialState,

  extraReducers: {
    [getApplicationUserEdit.fulfilled]: (state, { payload }) => {
      state.user = payload.data;
    },

    [getUser.fulfilled]: (state, { payload }) => {
      state.user = payload.data;
    },

    [applicationUserPaymentFeeWithUSDT.fulfilled]: (state, { payload }) => {
      state.user = payload.data;
    },
  },
});

export const { setAllNotifications } = userSlice.actions;

export default userSlice.reducer;
